import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import TableLoader from "../../Loaders/tableLoader";
import "../injuries.css";
import { getCaseId, getClientId, getToken } from "../../../Utils/helper";
import {
  addInjury,
  addPreexistingInjuries,
  modifyInjutries,
  modifyPreexistInjutries,
  setInjuriesData,
  // updateInjuries,
} from "../../../Redux/injuries/actions";
import ChatWithProviderModal from "../ChatProviderModal";
import FinalModal from "../FinalModal";
// import ProviderDocumentModal from "../ProviderDocumentModal";
import NoProviderModal from "../NoProviderModal";
import Warning from "../Warning.jsx";
import { api_without_cancellation } from "../../../api/api.js";
import EditModalProvider from "../EditModalProvider.js";
function mixColorWithWhite(hex, percentage) {
  const whitePercentage = (100 - percentage) / 100;

  let r = parseInt(hex?.slice(1, 3), 16);
  let g = parseInt(hex?.slice(3, 5), 16);
  let b = parseInt(hex?.slice(5, 7), 16);

  r = Math.floor(r + (255 - r) * whitePercentage);
  g = Math.floor(g + (255 - g) * whitePercentage);
  b = Math.floor(b + (255 - b) * whitePercentage);

  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}

const InjuryDashboard = ({ injuriesData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isNoOpen, setIsNoOpen] = useState(false);
  const [finalModalOpen, setFinalModalOpen] = useState(false);
  const [selectedInjuryId, setSelectedInjuryId] = useState(null);
  // const [providerModalOpen, setProviderModalOpen] = useState(false);
  // const [selectedProvider, setSelectedProvider] = useState(null);
  // const [selectedDetailId, setSelectedDetailId] = useState(null);
  const [showWarningModal, setShowWarningModal] = useState(false);

  const handleNoProviderOpen = () => {
    setIsNoOpen(!isNoOpen);
  };

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleFinalModalOpen = (injuryId) => {
    setSelectedInjuryId(injuryId);
    setFinalModalOpen(true);
  };

  const [editModal, setEditModal] = useState(false);
  const handleFinalModalOpen2 = (injuryId) => {
    setSelectedInjuryId(injuryId);
    setEditModal(true);
  };

  const handleFinalModalClose = () => {
    setFinalModalOpen(false);
  };

  // const handleProviderModalOpen = (provider, detailId, injuryId) => {
  //   setSelectedProvider(provider);
  //   setSelectedDetailId(detailId);
  //   setSelectedInjuryId(injuryId);
  //   setProviderModalOpen(true);
  // };

  // const handleProviderModalClose = () => {
  //   setProviderModalOpen(false);
  // };

  const handleWarningModalClose = () => {
    setShowWarningModal(false);
  };

  const { loading } = useSelector((state) => state.injuries);
  const dispatch = useDispatch();

  const origin = process.env.REACT_APP_BACKEND_URL;

  const addBodyPart = (bodyPart, image) => {
    addInjury({ body_part: bodyPart, client: false }, dispatch).then((res) => {
      if (res?.message === "Injury has details, cannot remove") {
        setShowWarningModal(true);
      } else {
        dispatch(
          modifyInjutries({
            redInjuries: res?.red_injuries,
            selectedPart: bodyPart,
            image: image,
            injuries: res?.injuries,
          })
        );
      }
    });
  };

  const handlePreexistingInjuries = (bodyPart) => {
    addPreexistingInjuries({
      injury_name: bodyPart,
      case_id: getCaseId(),
      client_id: getClientId(),
    }).then(() => {
      dispatch(
        modifyPreexistInjutries({
          selectedPart: bodyPart,
        })
      );
    });
  };
  const [providerAdding, setProviderAddingLoad] = useState(false);
  const addProviderFields = async (formData) => {
    try {
      const caseId = getCaseId();
      const clientId = getClientId();
      setProviderAddingLoad(true);
      const response = await fetch(
        origin +
          `/api/injuries/${selectedInjuryId}/add-details/?case_id=${caseId}&client_id=${clientId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
          },
          body: JSON.stringify(formData),
        }
      );

      // const data = await response.json();
      if (response.ok) {
        // dispatch(updateInjuries(data.injuries));

        try {
          const response = await api_without_cancellation.get(
            `/api/injury/${getClientId()}/${getCaseId()}/`
          );

          const data = response.data;
          dispatch(setInjuriesData(data));
          //  handleFinalModalClose();
        } catch (error) {
          console.error(error);
        } finally {
          setProviderAddingLoad(false);
          handleFinalModalClose();
        }
      }
    } catch (error) {
      console.error("Error updating injury details:", error);
      toast.error("Error Adding Provider");
    } finally {
      setProviderAddingLoad(false);
    }
  };

  const addProviderFields2 = async (formData) => {
    try {
      setProviderAddingLoad(true);
      const caseId = getCaseId();
      const clientId = getClientId();
      const response = await fetch(
        origin +
          `/api/injuries/${selectedInjuryId}/add-details/?case_id=${caseId}&client_id=${clientId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
          },
          body: JSON.stringify(formData),
        }
      );

      // const data = await response.json();
      if (response.ok) {
        // dispatch(updateInjuries(data.injuries));
        try {
          const response = await api_without_cancellation.get(
            `/api/injury/${getClientId()}/${getCaseId()}/`
          );

          const data = response.data;
          dispatch(setInjuriesData(data));
        } catch (error) {
          console.error(error);
        } finally {
          setProviderAddingLoad(false);
          setEditModal(false);
        }
      }
    } catch (error) {
      console.error("Error updating injury details:", error);
      toast.error("Error Updating Provider");
    } finally {
      setProviderAddingLoad(false);
    }
  };

  const deleteInjuryProvider = async () => {
    try {
      setProviderAddingLoad(true);
      const caseId = getCaseId();
      const clientId = getClientId();
      const response = await fetch(
        origin +
          `/api/injuries/${selectedInjuryId}/add-details/?case_id=${caseId}&client_id=${clientId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
          },
        }
      );

      // const data = await response.json();
      if (response.ok) {
        setEditModal(false);
        try {
          const response = await api_without_cancellation.get(
            `/api/injury/${getClientId()}/${getCaseId()}/`
          );

          const data = response.data;
          dispatch(setInjuriesData(data));
        } catch (error) {
          console.error(error);
        } finally {
          setProviderAddingLoad(false);
        }
      }
    } catch (error) {
      console.error("Error updating injury details:", error);
      toast.error("Error Deleting Provider");
    } finally {
      setProviderAddingLoad(false);
    }
  };

  const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = phoneNumberString.replace(/\D/g, "");
    const areaCode = cleaned.substring(0, 3);
    const firstThree = cleaned.substring(3, 6);
    const lastFour = cleaned.substring(6, 10);
    return `(${areaCode}) ${firstThree}-${lastFour}`;
  };

  return (
    <>
      {/*{loading && <TableLoader />}*/}
      <div className="red">
        {/* Main page */}
        {loading && <TableLoader />}
        {!loading && (
          <div className="injury-content-wrapper">
            <h4
              className="client-contact-title injuries-header text-center "
              style={{ marginTop: "0px" }}
            >
              Check the Client&apos;s Injured Body Parts
            </h4>
            <div className="injury-color-legend" role="list" aria-label="Injury color legend">
              <span className="injury-color-legend__item" role="listitem">
                <span
                  className="injury-color-legend__swatch injury-color-legend__swatch--current"
                  aria-hidden="true"
                />
                Current Case Injury
              </span>
              <span className="injury-color-legend__item" role="listitem">
                <span
                  className="injury-color-legend__swatch injury-color-legend__swatch--pre-existing"
                  aria-hidden="true"
                />
                Pre-Existing Injury
              </span>
              <span className="injury-color-legend__item" role="listitem">
                <span
                  className="injury-color-legend__swatch injury-color-legend__swatch--provider"
                  aria-hidden="true"
                />
                Medical Provider Linked
              </span>
            </div>

            {/* Human Skeleton and Spinal Cord Skeletion*/}
            <div className="ps-0 pe-0 m-b-5 m-t-5">
              <div className="injury-main-container h-100">
                <div
                  className="ps-0 d-flex align-items-center pe-0 m-r-10"
                  style={{
                    gap: "15px",
                    flex: "1",
                  }}
                >
                  {/* First Part is just rendering the image either with injuries or plain */}
                  <div
                    className="p-0 injury-img-none"
                    style={{
                      position: "relative",
                      minWidth: "220px",
                      flex: "1",
                    }}
                    id="body-svg-images"
                  >
                    {/* Render the base image */}
                    <img
                      src={`https://d1jidr14kflwe7.cloudfront.net/static/${injuriesData?.base_img}`}
                      className="svg-base svg-base-2 height-500px"
                      alt="Base Image"
                    />

                    {/* Iterate over the body parts data */}
                    {injuriesData?.body_url?.map((url) => (
                      <React.Fragment key={url[1]}>
                        {injuriesData?.pre_existing_injuries?.includes(url[1]) ? (
                          // ||
                          // injuriesData?.injuries_selected_or_found_earlier.includes(
                          //   url[1]
                          // )
                          <img
                            src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].pink}`}
                            id={`${url[1].replace(/\s/g, "_")}_pink`}
                            alt="Responsive image"
                            className="svg max-height-500px-display-inherit"
                          />
                        ) : (
                          <img
                            // src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].pink}`}
                            id={`${url[1].replace(/\s/g, "_")}_pink`}
                            alt="Responsive image"
                            className="svg max-height-500px-display-none"
                          />
                        )}
                        {injuriesData?.blue_injuries?.includes(url[1]) ? (
                          <img
                            src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].blue}`}
                            id={url[1]}
                            alt="Responsive image"
                            className="svg max-height-500px-display-inherit"
                          />
                        ) : injuriesData?.green_injuries?.includes(url[1]) ? (
                          <img
                            src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].green}`}
                            id={url[1]}
                            alt="Responsive image"
                            className="svg max-height-500px-display-inherit"
                          />
                        ) : injuriesData?.red_injuries?.includes(url[1]) ? (
                          <img
                            src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].red}`}
                            id={url[1]}
                            alt="Responsive image"
                            className="svg max-height-500px-display-inherit"
                          />
                        ) : (
                          injuriesData?.orange_injuries?.includes(url[1]) && (
                            <img
                              src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].orange}`}
                              id={url[1]}
                              alt="Responsive image"
                              className="svg max-height-500px-display-inherit"
                            />
                          )
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                  {/* This Part is main concerning since checking off the injuries with this */}
                  <div
                    className="p-0"
                    style={{
                      flex: "1",
                    }}
                  >
                    <section
                      className="injires display-flex-justify-content-space-between-width-100"
                      style={{
                        gap: "15px",
                      }}
                    >
                      {/* <form id="form1">
                        <input type="text" name="body_part" id="body_part" hidden />
                      </form> */}
                      <div className="checklist max-height-500px-display-flex-flex-direction-column-flex-wrap-wrap">
                        {injuriesData?.body_parts_1?.map(([bodyPart, displayName]) => (
                          <div className="d-flex align-items-center" key={bodyPart}>
                            <div
                              className="width-custom d-flex align-items-center"
                              style={{
                                gap: "5px",
                              }}
                            >
                              <input
                                type="checkbox"
                                onClick={() => addBodyPart(bodyPart, "skeleton")}
                                id={bodyPart}
                                name={bodyPart}
                                value={bodyPart}
                                checked={injuriesData?.selected_body_parts?.includes(bodyPart)}
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                className={`form-check mb-0 ${
                                  injuriesData?.blue_injuries?.includes(bodyPart)
                                    ? "blue-accent-color"
                                    : injuriesData?.green_injuries?.includes(bodyPart)
                                      ? "green-accent-color"
                                      : injuriesData?.orange_injuries?.includes(bodyPart)
                                        ? "orange-accent-color"
                                        : injuriesData?.red_injuries?.includes(bodyPart)
                                          ? "red-accent-color"
                                          : ""
                                }`}
                              />
                              <label htmlFor={bodyPart} className="mb-0">
                                {displayName}
                              </label>
                            </div>
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                id={`${bodyPart}_pink`}
                                name={bodyPart}
                                value={`${bodyPart}_pink`}
                                onChange={() => handlePreexistingInjuries(bodyPart)}
                                checked={
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    bodyPart
                                  ) || injuriesData?.pre_existing_injuries?.includes(bodyPart)
                                }
                                className={`form-check mb-0 mb-0 ${
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    bodyPart
                                  )
                                    ? "pink-accent-color-v2"
                                    : ""
                                } ${
                                  injuriesData?.pre_existing_injuries?.includes(bodyPart)
                                    ? "pink-accent-color"
                                    : ""
                                }   hover-event-img`}
                              />
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="checklist max-height-500px-display-flex-flex-direction-column-flex-wrap-wrap">
                        {injuriesData?.body_parts_2?.map(([bodyPart, displayName]) => (
                          // <div className="d-flex align-items-center" key={body_part}>
                          //   <div className="width-custom">
                          //     {injuriesData?.selected_body_parts?.includes(body_part) ? (
                          //       <input
                          //         className={`${
                          //           injuriesData?.blue_injuries?.includes(body_part)
                          //             ? "blue-accent-color"
                          //             : injuriesData?.green_injuries?.includes(body_part)
                          //               ? "green-accent-color"
                          //               : injuriesData?.orange_injuries?.includes(body_part)
                          //                 ? "orange-accent-color"
                          //                 : injuriesData?.red_injuries?.includes(body_part)
                          //                   ? "red-accent-color"
                          //                   : ""
                          //         }`}
                          //         type="checkbox"
                          //         onClick={() => addBodyPart(body_part, "skeleton")}
                          //         id={body_part}
                          //         name={body_part}
                          //         value={body_part}
                          //         checked
                          //         style={{
                          //           cursor: "pointer",
                          //         }}
                          //       />
                          //     ) : (
                          //       <input
                          //         type="checkbox"
                          //         id={body_part}
                          //         name={body_part}
                          //         value={body_part}
                          //         onClick={() => addBodyPart(body_part, "skeleton")}
                          //         style={{
                          //           cursor: "pointer",
                          //         }}
                          //       />
                          //     )}
                          //     <label htmlFor={body_part} className="ms-2">
                          //       {display_name}
                          //     </label>
                          //   </div>
                          //   <div className="m-r-10">
                          //     <input
                          //       type="checkbox"
                          //       style={{
                          //         cursor: "pointer",
                          //       }}
                          //       id={`${body_part}_pink`}
                          //       name={body_part}
                          //       value={`${body_part}_pink`}
                          //       onChange={() => handlePreexistingInjuries(body_part)}
                          //       checked={
                          //         injuriesData?.injuries_selected_or_found_earlier?.includes(
                          //           body_part
                          //         ) || injuriesData?.pre_existing_injuries?.includes(body_part)
                          //       }
                          //       className={` ${
                          //         injuriesData?.injuries_selected_or_found_earlier?.includes(
                          //           body_part
                          //         )
                          //           ? "pink-accent-color-v2"
                          //           : ""
                          //       } ${
                          //         injuriesData?.pre_existing_injuries?.includes(body_part)
                          //           ? "pink-accent-color"
                          //           : ""
                          //       }   hover-event-img`}
                          //     />
                          //   </div>
                          // </div>
                          <div className="d-flex align-items-center" key={bodyPart}>
                            <div
                              className="width-custom d-flex align-items-center"
                              style={{
                                gap: "5px",
                              }}
                            >
                              <input
                                type="checkbox"
                                onClick={() => addBodyPart(bodyPart, "skeleton")}
                                id={bodyPart}
                                name={bodyPart}
                                value={bodyPart}
                                checked={injuriesData?.selected_body_parts?.includes(bodyPart)}
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                className={`form-check mb-0 ${
                                  injuriesData?.blue_injuries?.includes(bodyPart)
                                    ? "blue-accent-color"
                                    : injuriesData?.green_injuries?.includes(bodyPart)
                                      ? "green-accent-color"
                                      : injuriesData?.orange_injuries?.includes(bodyPart)
                                        ? "orange-accent-color"
                                        : injuriesData?.red_injuries?.includes(bodyPart)
                                          ? "red-accent-color"
                                          : ""
                                }`}
                              />
                              <label htmlFor={bodyPart} className="mb-0">
                                {displayName}
                              </label>
                            </div>
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                id={`${bodyPart}_pink`}
                                name={bodyPart}
                                value={`${bodyPart}_pink`}
                                onChange={() => handlePreexistingInjuries(bodyPart)}
                                checked={
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    bodyPart
                                  ) || injuriesData?.pre_existing_injuries?.includes(bodyPart)
                                }
                                className={`form-check mb-0 ${
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    bodyPart
                                  )
                                    ? "pink-accent-color-v2"
                                    : ""
                                } ${
                                  injuriesData?.pre_existing_injuries?.includes(bodyPart)
                                    ? "pink-accent-color"
                                    : ""
                                }   hover-event-img`}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>
                </div>

                {/* Spinal Cord Image and Checkboxes */}
                <div
                  style={{
                    gap: "15px",
                    flex: "1",
                  }}
                  className="spinal-cord-div d-flex align-items-center ps-0 pe-0 m-r-10"
                >
                  <div
                    className="p-0 injury-img-none"
                    style={{
                      position: "relative",
                      minWidth: "220px",
                      flex: "1",
                    }}
                    id="spine-svg-images"
                  >
                    <img
                      src={`https://d1jidr14kflwe7.cloudfront.net/static/${injuriesData?.spine_img}`}
                      className="svg-base svg-base-2 height-500px"
                      alt="Spine"
                    />

                    {injuriesData?.spine_url?.map((url) => {
                      return (
                        <React.Fragment key={url[1]}>
                          {injuriesData?.pre_existing_injuries?.includes(url[1]) ||
                          injuriesData?.injuries_selected_or_found_earlier?.includes(url[1]) ? (
                            <img
                              src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].pink}`}
                              id={`${url[1].replace(/\s/g, "_")}_pink`}
                              alt="Responsive image"
                              className="svg max-height-500px-display-inherit"
                            />
                          ) : (
                            <img
                              src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].pink}`}
                              id={`${url[1].replace(/\s/g, "_")}_pink`}
                              alt="Responsive image"
                              className="svg max-height-500px-display-none"
                            />
                          )}
                          {injuriesData?.blue_injuries?.includes(url[1]) ? (
                            <img
                              src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].blue}`}
                              id={url[1]}
                              alt="Responsive image"
                              className="svg max-height-500px-display-inherit"
                            />
                          ) : injuriesData?.green_injuries?.includes(url[1]) ? (
                            <img
                              src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].green}`}
                              id={url[1]}
                              alt="Responsive image"
                              className="svg max-height-500px-display-inherit"
                            />
                          ) : injuriesData?.red_injuries?.includes(url[1]) ? (
                            <img
                              src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].red}`}
                              id={url[1]}
                              alt="Responsive image"
                              className="svg max-height-500px-display-inherit"
                            />
                          ) : (
                            injuriesData?.orange_injuries?.includes(url[1]) && (
                              <img
                                src={`https://d1jidr14kflwe7.cloudfront.net/static/${url[0].orange}`}
                                id={url[1]}
                                alt="Responsive image"
                                className="svg max-height-500px-display-inherit"
                              />
                            )
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                  <div
                    className="p-0"
                    style={{
                      flex: "1",
                    }}
                  >
                    <section
                      className="injires display-flex-justify-content-space-between"
                      style={{
                        gap: "15px",
                      }}
                    >
                      <div className="checklist max-height-500px-display-flex-flex-direction-column-flex-wrap-wrap">
                        {injuriesData?.spine_parts_1?.map(([body_part, display_name]) => (
                          <div
                            key={body_part}
                            // id="spinal-checkboxes"
                            className="d-flex align-items-center"
                          >
                            <div
                              className="width-custom d-flex align-items-center"
                              style={{
                                gap: "5px",
                              }}
                            >
                              <input
                                type="checkbox"
                                onClick={() => addBodyPart(body_part, "spine")}
                                id={body_part}
                                name={body_part}
                                value={body_part}
                                checked={injuriesData?.selected_body_parts?.includes(body_part)}
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                className={`form-check mb-0 ${
                                  injuriesData?.blue_injuries?.includes(body_part)
                                    ? "blue-accent-color"
                                    : injuriesData?.green_injuries?.includes(body_part)
                                      ? "green-accent-color"
                                      : injuriesData?.orange_injuries?.includes(body_part)
                                        ? "orange-accent-color"
                                        : injuriesData?.red_injuries?.includes(body_part)
                                          ? "red-accent-color"
                                          : ""
                                }`}
                              />
                              {/* {injuriesData?.selected_spine_parts?.includes(body_part) ? (
                                
                                <input
                                  className={`form-check mb-0 ${
                                    injuriesData?.blue_injuries?.includes(body_part)
                                      ? "blue-accent-color"
                                      : injuriesData?.green_injuries?.includes(body_part)
                                        ? "green-accent-color"
                                        : injuriesData?.orange_injuries?.includes(body_part)
                                          ? "orange-accent-color"
                                          : injuriesData?.red_injuries?.includes(body_part)
                                            ? "red-accent-color"
                                            : ""
                                  }`}
                                  type="checkbox"
                                  onClick={() => addBodyPart(body_part, "spine")}
                                  id={body_part}
                                  name={body_part}
                                  value={body_part}
                                  checked
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                />
                              ) : (
                                <input
                                  type="checkbox"
                                  onClick={() => addBodyPart(body_part, "spine")}
                                  className={`form-check mb-0 ${
                                    injuriesData?.blue_injuries?.includes(body_part)
                                      ? "blue-accent-color"
                                      : injuriesData?.green_injuries?.includes(body_part)
                                        ? "green-accent-color"
                                        : injuriesData?.orange_injuries?.includes(body_part)
                                          ? "orange-accent-color"
                                          : injuriesData?.red_injuries?.includes(body_part)
                                            ? "red-accent-color"
                                            : ""
                                  }`}
                                  id={body_part}
                                  name={body_part}
                                  value={body_part}
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                />
                              )} */}
                              <label htmlFor={body_part} className="mb-0">
                                {display_name}
                              </label>
                            </div>
                            {/* <div className="d-flex align-items-center">
                              {injuriesData?.injuries_selected_or_found_earlier?.includes(
                                body_part
                              ) ? (
                                <input
                                  className="pink-accent-color-v2 form-check mb-0"
                                  type="checkbox"
                                  id={body_part}
                                  name={body_part}
                                  value={`${body_part}_pink`}
                                  onChange={() => handlePreexistingInjuries(body_part)}
                                  checked
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                />
                              ) : injuriesData?.pre_existing_injuries?.includes(body_part) ? (
                                <input
                                  className="pink-accent-color form-check mb-0"
                                  type="checkbox"
                                  id={body_part}
                                  name={body_part}
                                  value={`${body_part}_pink`}
                                  checked
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                  onChange={() => handlePreexistingInjuries(body_part)}
                                />
                              ) : (
                                <input
                                  className="pink-accent-color form-check mb-0 hover-event-img"
                                  type="checkbox"
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                  id={body_part}
                                  name={body_part}
                                  value={`${body_part}_pink`}
                                  onChange={() => handlePreexistingInjuries(body_part)}
                                />
                              )}
                            </div> */}
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                id={`${body_part}_pink`}
                                name={body_part}
                                value={`${body_part}_pink`}
                                onChange={() => handlePreexistingInjuries(body_part)}
                                checked={
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    body_part
                                  ) || injuriesData?.pre_existing_injuries?.includes(body_part)
                                }
                                className={`form-check mb-0 ${
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    body_part
                                  )
                                    ? "pink-accent-color-v2"
                                    : ""
                                } ${
                                  injuriesData?.pre_existing_injuries?.includes(body_part)
                                    ? "pink-accent-color"
                                    : ""
                                }   hover-event-img`}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="checklist max-height-500px-display-flex-flex-direction-column-flex-wrap-wrap">
                        {injuriesData?.spine_parts_2?.map(([body_part, display_name]) => (
                          // <div key={body_part} className="d-flex align-items-center">
                          //   <div className="width-custom-3">
                          //     {injuriesData?.selected_spine_parts?.includes(body_part) ? (
                          //       <input
                          //         className={`${
                          //           injuriesData?.blue_injuries?.includes(body_part)
                          //             ? "blue-accent-color"
                          //             : injuriesData?.red_injuries?.includes(body_part)
                          //               ? "red-accent-color"
                          //               : injuriesData?.orange_injuries?.includes(body_part)
                          //                 ? "orange-accent-color"
                          //                 : injuriesData?.green_injuries?.includes(body_part)
                          //                   ? "green-accent-color"
                          //                   : ""
                          //         }`}
                          //         type="checkbox"
                          //         onClick={() => addBodyPart(body_part, "spine")}
                          //         id={body_part}
                          //         name={body_part}
                          //         value={body_part}
                          //         checked
                          //         style={{
                          //           cursor: "pointer",
                          //         }}
                          //       />
                          //     ) : (
                          //       <input
                          //         type="checkbox"
                          //         style={{
                          //           cursor: "pointer",
                          //         }}
                          //         onClick={() => addBodyPart(body_part, "spine")}
                          //         id={body_part}
                          //         name={body_part}
                          //         value={body_part}
                          //       />
                          //     )}
                          //     <label htmlFor={body_part} className="ms-2">
                          //       {display_name}
                          //     </label>
                          //   </div>
                          //   <div className="pink-accent-container">
                          //     {injuriesData?.injuries_selected_or_found_earlier?.includes(
                          //       body_part
                          //     ) ? (
                          //       <input
                          //         className="pink-accent-color-v2"
                          //         type="checkbox"
                          //         id={body_part}
                          //         name={body_part}
                          //         value={`${body_part}_pink`}
                          //         onChange={() => handlePreexistingInjuries(body_part)}
                          //         checked
                          //         style={{
                          //           cursor: "pointer",
                          //         }}
                          //       />
                          //     ) : injuriesData?.pre_existing_injuries?.includes(body_part) ? (
                          //       <input
                          //         className="pink-accent-color"
                          //         type="checkbox"
                          //         id={body_part}
                          //         name={body_part}
                          //         value={`${body_part}_pink`}
                          //         checked
                          //         style={{
                          //           cursor: "pointer",
                          //         }}
                          //         onChange={() => handlePreexistingInjuries(body_part)}
                          //       />
                          //     ) : (
                          //       <input
                          //         style={{
                          //           cursor: "pointer",
                          //         }}
                          //         className="pink-accent-color hover-event-img"
                          //         type="checkbox"
                          //         id={body_part}
                          //         name={body_part}
                          //         value={`${body_part}_pink`}
                          //         onChange={() => handlePreexistingInjuries(body_part)}
                          //       />
                          //     )}
                          //   </div>
                          // </div>
                          <div
                            key={body_part}
                            id="spinal-checkboxes"
                            className="d-flex align-items-center"
                          >
                            <div
                              className="width-custom d-flex align-items-center"
                              style={{
                                gap: "5px",
                              }}
                            >
                              <input
                                type="checkbox"
                                onClick={() => addBodyPart(body_part, "spine")}
                                id={body_part}
                                name={body_part}
                                value={body_part}
                                checked={injuriesData?.selected_body_parts?.includes(body_part)}
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                className={`form-check mb-0 ${
                                  injuriesData?.blue_injuries?.includes(body_part)
                                    ? "blue-accent-color"
                                    : injuriesData?.green_injuries?.includes(body_part)
                                      ? "green-accent-color"
                                      : injuriesData?.orange_injuries?.includes(body_part)
                                        ? "orange-accent-color"
                                        : injuriesData?.red_injuries?.includes(body_part)
                                          ? "red-accent-color"
                                          : ""
                                }`}
                              />
                              {/* {injuriesData?.selected_spine_parts?.includes(body_part) ? (
                                <input
                                  className={`form-check mb-0 ${
                                    injuriesData?.blue_injuries?.includes(body_part)
                                      ? "blue-accent-color"
                                      : injuriesData?.green_injuries?.includes(body_part)
                                        ? "green-accent-color"
                                        : injuriesData?.orange_injuries?.includes(body_part)
                                          ? "orange-accent-color"
                                          : injuriesData?.red_injuries?.includes(body_part)
                                            ? "red-accent-color"
                                            : ""
                                  }`}
                                  type="checkbox"
                                  onClick={() => addBodyPart(body_part, "spine")}
                                  id={body_part}
                                  name={body_part}
                                  value={body_part}
                                  checked
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                />
                              ) : (
                                <input
                                  type="checkbox"
                                  onClick={() => addBodyPart(body_part, "spine")}
                                  className={`form-check mb-0 ${
                                    injuriesData?.blue_injuries?.includes(body_part)
                                      ? "blue-accent-color"
                                      : injuriesData?.green_injuries?.includes(body_part)
                                        ? "green-accent-color"
                                        : injuriesData?.orange_injuries?.includes(body_part)
                                          ? "orange-accent-color"
                                          : injuriesData?.red_injuries?.includes(body_part)
                                            ? "red-accent-color"
                                            : ""
                                  }`}
                                  id={body_part}
                                  name={body_part}
                                  value={body_part}
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                />
                              )} */}
                              <label htmlFor={body_part} className="mb-0">
                                {display_name}
                              </label>
                            </div>
                            {/* <div className="d-flex align-items-center">
                              {injuriesData?.injuries_selected_or_found_earlier?.includes(
                                body_part
                              ) ? (
                                <input
                                  className="pink-accent-color-v2 form-check mb-0"
                                  type="checkbox"
                                  id={body_part}
                                  name={body_part}
                                  value={`${body_part}_pink`}
                                  onChange={() => handlePreexistingInjuries(body_part)}
                                  checked
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                />
                              ) : injuriesData?.pre_existing_injuries?.includes(body_part) ? (
                                <input
                                  className="pink-accent-color form-check mb-0"
                                  type="checkbox"
                                  id={body_part}
                                  name={body_part}
                                  value={`${body_part}_pink`}
                                  checked
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                  onChange={() => handlePreexistingInjuries(body_part)}
                                />
                              ) : (
                                <input
                                  className="pink-accent-color form-check mb-0 hover-event-img"
                                  type="checkbox"
                                  style={{
                                    cursor: "pointer",
                                    top: "0px",
                                    lineHeight: "21px",
                                  }}
                                  id={body_part}
                                  name={body_part}
                                  value={`${body_part}_pink`}
                                  onChange={() => handlePreexistingInjuries(body_part)}
                                />
                              )}
                            </div> */}
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                style={{
                                  cursor: "pointer",
                                  top: "0px",
                                  lineHeight: "21px",
                                }}
                                id={`${body_part}_pink`}
                                name={body_part}
                                value={`${body_part}_pink`}
                                onChange={() => handlePreexistingInjuries(body_part)}
                                checked={
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    body_part
                                  ) || injuriesData?.pre_existing_injuries?.includes(body_part)
                                }
                                className={`form-check mb-0 ${
                                  injuriesData?.injuries_selected_or_found_earlier?.includes(
                                    body_part
                                  )
                                    ? "pink-accent-color-v2"
                                    : ""
                                } ${
                                  injuriesData?.pre_existing_injuries?.includes(body_part)
                                    ? "pink-accent-color"
                                    : ""
                                }   hover-event-img`}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Section Table */}

            <div className="table-responsive table--no-card border-0 m-b-5">
              <table className="table table-borderless table-striped table-earning injuires-table injury-provider-table has-height-25">
                <thead>
                  <tr id="tb-header">
                    <th
                      className=""
                      style={{
                        minWidth: "25px",
                        maxWidth: "25px",
                        width: "25px",
                      }}
                    />
                    <th className="td-autosize ">Body Part</th>
                    <th
                      style={{
                        minWidth: "25px",
                        maxWidth: "25px",
                        width: "25px",
                      }}
                    />
                    <th className="text-center td-autosize">Treating Medical Provider</th>

                    <th
                      className="text-center td-autosize"
                      style={{
                        minWidth: "120px",
                      }}
                    >
                      PHONE
                    </th>
                    <th className="injury-note-spacer" aria-hidden="true" />
                    <th className="injury-note-cell text-center">Note</th>
                    <th className="injury-note-spacer" aria-hidden="true" />
                  </tr>
                </thead>
                <tbody id="injuries-table">
                  {injuriesData?.injuries?.map((injury, index) => {
                    // Check if there are injury details available
                    if (injury.injury_details && injury.injury_details.length > 0) {
                      return injury.injury_details.map((detail, detailIndex) => {
                        const specialtyColor = detail?.provider?.specialty?.color;
                        const backgroundColor = mixColorWithWhite(specialtyColor, 10);
                        const isFirstRow = detailIndex === 0;
                        return (
                          <tr
                            className={`hover has-speciality-color-${detail?.provider?.specialty?.id}`}
                            //onClick={() => handleFinalModalOpen(injury.id)}
                            data-body-part={injury?.body_part?.name}
                            injury-id={injury?.id}
                            id={`injury_row${injury?.id}`}
                            key={`injury_row${injury?.id}_${detail?.id}`} // Adding detail id to ensure unique keys
                          >
                            <td onClick={() => handleFinalModalOpen2(injury.id)}>
                              {isFirstRow ? index + 1 : ""}
                            </td>
                            <td
                              className="text-start"
                              style={{
                                fontWeight: "600",
                              }}
                              onClick={() => handleFinalModalOpen2(injury.id)}
                            >
                              {isFirstRow ? injury?.body_part?.name : ""}
                            </td>
                            <td onClick={() => handleFinalModalOpen2(injury.id)} />
                            <td
                              className={`provider-field td_provider_name_${injury.id} bg-speciality-10`}
                              id="provider-td"
                              // onClick={handleOpen}
                              onClick={() => handleFinalModalOpen2(injury.id)}
                            >
                              <div
                                className="d-flex w-100 h-100"
                                style={{
                                  backgroundColor: backgroundColor,
                                }}
                              >
                                <div
                                  className={`td_name_${injury?.id} d-flex align-items-center h-100 text-center justify-content-center font-weight-600 color-white p-0`}
                                  style={{
                                    background: `${detail?.provider?.specialty?.color}`,
                                    fontWeight: "600",
                                    width: "25px",
                                    minHeight: "25px",
                                    fontSize: "14px",
                                  }}
                                  // id="max-h-25"
                                >
                                  {detail?.provider?.specialty?.name?.charAt(0)}
                                </div>
                                <div
                                  className="align-self-center m-l-5"
                                  style={{
                                    fontWeight: "600",
                                  }}
                                >
                                  <div>
                                    {" "}
                                    {
                                      detail?.provider?.location?.added_by?.providerprofile
                                        ?.office_name
                                    }
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td
                              className={`td_phone_${injury.id}`}
                              onClick={() => handleFinalModalOpen2(injury.id)}
                              style={{
                                backgroundColor: backgroundColor,
                                fontWeight: "600",
                              }}
                            >
                              {detail?.provider?.location?.phone
                                ? formatPhoneNumber(detail?.provider?.location?.phone)
                                : ""}
                            </td>
                            <td
                              className="injury-note-spacer"
                              aria-hidden="true"
                              style={{ backgroundColor }}
                              onClick={() => handleFinalModalOpen2(injury.id)}
                            />
                            <td
                              className="injury-note-cell text-start"
                              style={{
                                backgroundColor,
                                fontWeight: "600",
                              }}
                              onClick={() => handleFinalModalOpen2(injury.id)}
                            >
                              <span className="injury-note-text">{detail?.note}</span>
                            </td>
                            <td
                              className="injury-note-spacer"
                              aria-hidden="true"
                              style={{ backgroundColor }}
                              onClick={() => handleFinalModalOpen2(injury.id)}
                            />
                          </tr>
                        );
                      });
                    } else {
                      // If there are no details for this injury, display a placeholder row with the body part name
                      return (
                        <tr
                          //onClick={() => handleFinalModalOpen(injury.id)}
                          className={"hover has-speciality-color-"}
                          data-body-part={injury?.body_part}
                          injury-id={injury?.id}
                          id={`injury_row${injury?.id}`}
                          key={`injury_row${injury?.id}`}
                        >
                          <td onClick={() => handleFinalModalOpen(injury.id)}>
                            <div>{index + 1}</div>
                          </td>
                          <td
                            className="text-start"
                            style={{
                              fontWeight: "600",
                            }}
                            onClick={() => handleFinalModalOpen(injury.id)}
                          >
                            {injury?.body_part?.name}
                          </td>
                          <td onClick={() => handleFinalModalOpen(injury.id)} />
                          <td
                            className={`provider-field td_provider_name_${injury.id}`}
                            id="provider-td"
                            // onClick={handleOpen}
                            onClick={() => handleFinalModalOpen(injury.id)}
                          />

                          <td
                            className={`td_phone_${injury.id}`}
                            onClick={() => handleFinalModalOpen(injury.id)}
                          />
                          <td
                            className="injury-note-spacer"
                            aria-hidden="true"
                            onClick={() => handleFinalModalOpen(injury.id)}
                          />
                          <td
                            className="injury-note-cell text-start"
                            onClick={() => handleFinalModalOpen(injury.id)}
                          />
                          <td
                            className="injury-note-spacer"
                            aria-hidden="true"
                            onClick={() => handleFinalModalOpen(injury.id)}
                          />
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {isOpen && <ChatWithProviderModal handleOpen={handleOpen} isOpen={isOpen} />}
        {finalModalOpen && (
          <FinalModal
            show={finalModalOpen}
            handleClose={handleFinalModalClose}
            injuryId={selectedInjuryId}
            onSave={addProviderFields}
            providerAdding={providerAdding}
          />
        )}
        {editModal && (
          <EditModalProvider
            show={editModal}
            handleClose={() => setEditModal(false)}
            injuryId={selectedInjuryId}
            onSave={addProviderFields2}
            onDelete={deleteInjuryProvider}
            providerAdding={providerAdding}
          />
        )}
        {/* {selectedProvider && (
          <ProviderDocumentModal
            show={providerModalOpen}
            handleClose={handleProviderModalClose}
            provider={selectedProvider}
            processedPageSlots={injuriesData?.processed_page_slots || []}
            injuryId={selectedInjuryId}
            detailId={selectedDetailId}
          />
        )} */}
        {isNoOpen && <NoProviderModal handleOpen={handleNoProviderOpen} isOpen={isNoOpen} />}

        {showWarningModal && (
          <Warning show={showWarningModal} handleClose={handleWarningModalClose} />
        )}
      </div>
    </>
  );
};

export default InjuryDashboard;
